import Avatar from '@mui/material/Avatar'
import Chip from '@mui/material/Chip'
import { useTheme } from '@mui/material/styles'
import React from 'react'

import { UNASSIGNED_ROUTE } from 'containers/new-route-manager/settings'
import { ALPHA_38_PERCENT } from 'theme/colors'

const UnassignedChip = () => {
  const theme = useTheme()
  return (
    <Chip
      size="small"
      avatar={<Avatar sx={{ backgroundColor: `${theme.palette.background.black}${ALPHA_38_PERCENT}` }}>U</Avatar>}
      label={UNASSIGNED_ROUTE.name}
      variant="outlined"
      sx={{
        '& .MuiChip-avatar': {
          color: 'background.paper',
        },
      }}
    />
  )
}

export default UnassignedChip
